import {
  divideByFactor,
  multiplyByFactor,
  PRICE_ROUNDING_FACTOR,
} from '../../../../../utils/prices'

export const getOptionValue = (value: number | null | undefined) => {
  return value || value === 0 ? multiplyByFactor(value) : undefined
}

export const formatPriceToString = (price: number | null | undefined) => {
  return price || price === 0 ? divideByFactor(price).toString() : undefined
}

export const formatStringToPrice = (input: string | null | undefined) => {
  return input ? Math.floor(Number(input) * PRICE_ROUNDING_FACTOR) : undefined
}

export const getVatRateOptions = (vatRates: number[]) => {
  return vatRates.map((vatRate) => ({
    label: `${divideByFactor(vatRate)} %`,
    value: vatRate,
  }))
}
